var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpIcon8216B310(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1830.25 -25.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1888.25 25.75) rotate(90)",
    fill: "#fff",
    stroke: "#34a853",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 28.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.187-29.377a11.357,11.357,0,0,1,4.68.923,7.45,7.45,0,0,1,3.219,2.626A6.9,6.9,0,0,1,9.24-21.863a6.484,6.484,0,0,1-1.154,3.889,23.551,23.551,0,0,1-3.351,3.582A29.876,29.876,0,0,0,2.3-11.942a3.7,3.7,0,0,0-.9,2.186v.571h-4.68v-.571a6.116,6.116,0,0,1,1.11-3.713A21.258,21.258,0,0,1,1-16.787a22.151,22.151,0,0,0,2.494-2.527,3.585,3.585,0,0,0,.78-2.285,3.309,3.309,0,0,0-1.165-2.659,4.557,4.557,0,0,0-3.054-.989,4.5,4.5,0,0,0-3.329,1.263,4.054,4.054,0,0,0-1.176,3.2H-9.218a8.158,8.158,0,0,1,1.1-4.351,8.106,8.106,0,0,1,3.307-3.1A10.55,10.55,0,0,1,.187-29.377ZM-.846-6.35a3.649,3.649,0,0,1,2.538.967,3.226,3.226,0,0,1,1.066,2.5A3.122,3.122,0,0,1,1.714-.417,3.727,3.727,0,0,1-.846.505,3.716,3.716,0,0,1-3.417-.417,3.138,3.138,0,0,1-4.449-2.878a3.275,3.275,0,0,1,1.033-2.5A3.617,3.617,0,0,1-.846-6.35Z",
    transform: "translate(1859 70)",
    fill: "#34a853"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon8216B310);
export default __webpack_public_path__ + "static/media/helpIcon.8216b310.8216b310b1c0906023f73d8619357671.svg";
export { ForwardRef as ReactComponent };